import { render, staticRenderFns } from "./myexamination.vue?vue&type=template&id=e07163be&scoped=true"
import script from "./myexamination.vue?vue&type=script&lang=js"
export * from "./myexamination.vue?vue&type=script&lang=js"
import style0 from "./myexamination.vue?vue&type=style&index=0&id=e07163be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07163be",
  null
  
)

export default component.exports